import validateForm from 'services/validate_form'
import { eventTypeSelector } from 'root-api'

export const validateScheduling = (formData) => (dispatch, getState) => {
  dispatch({ type: 'SCHEDULING_VALIDATION_REQUEST' })

  return new Promise(((resolve) => {
    const validation = validateForm(formData, {
      state: getState(),
      isMultiLocation: eventTypeSelector(getState()).location_configurations.length > 1
    })

    if (!validation.valid) {
      dispatch({
        type: 'SCHEDULING_VALIDATION_FAIL',
        payload: {
          errors: validation.errors
        }
      })
      return resolve(false)
    }

    dispatch({ type: 'SCHEDULING_VALIDATION_DONE' })
    return resolve(true)
  }))
}
